/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const LEGACY_PERSONAL_SETTINGS_PATH = '/secure/ViewPersonalSettings.jspa';

export const BASE_PERSONAL_SETTINGS_PATH = '/jira/settings/personal';

export const GENERAL_PERSONAL_SETTINGS_PATH: '/jira/settings/personal/general' = `${BASE_PERSONAL_SETTINGS_PATH}/general`;

export const NOTIFICATIONS_PERSONAL_SETTINGS_PATH: '/jira/settings/personal/notifications' = `${BASE_PERSONAL_SETTINGS_PATH}/notifications`;

export const DIGEST_NOTIFICATIONS_PERSONAL_SETTINGS_PATH: '/jira/settings/personal/digests' = `${BASE_PERSONAL_SETTINGS_PATH}/digests`;

export const APPS_PERSONAL_SETTINGS_PATH: '/jira/settings/personal/apps' = `${BASE_PERSONAL_SETTINGS_PATH}/apps`;

export const OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH: '/jira/settings/personal/alert-notifications' = `${BASE_PERSONAL_SETTINGS_PATH}/alert-notifications`;

export function getGeneralPersonalSettingsPath(): string {
	return GENERAL_PERSONAL_SETTINGS_PATH;
}

export function getOpsPersonalSettingsPath(): string {
	return OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH;
}

export function getNotificationsPersonalSettingsPath(): string {
	return NOTIFICATIONS_PERSONAL_SETTINGS_PATH;
}

export function getAppsPersonalSettingsPath(): string {
	return APPS_PERSONAL_SETTINGS_PATH;
}
